<script setup>
import { computed, ref } from "vue";
import BarChartCard from "@/components/BarChartCard.vue";
import fetchData from "@/utils/fetchData";

const popular = ref([]);
fetchData("getPopularJourneyData").then((rows) => (popular.value = rows));

// The API counts prompts in lower case so "CV" and "cv" are one
const rows = computed(() =>
  popular.value.map((row) => ({
    x: row.x.charAt(0).toUpperCase() + row.x.slice(1),
    y: row.y,
  }))
);
</script>

<template>
  <BarChartCard
    title="Most requested makes"
    note="All time, by what people typed"
    :rows="rows"
  />
</template>
